import React, {useState, useEffect, useRef} from 'react';
import { useParams, Redirect } from "react-router-dom";
import { DownloadTableExcel, downloadExcel } from 'react-export-table-to-excel';

import httpClient from '../fetch/fetch';
import {toast} from "react-toastify"
import moment from 'moment/moment';

import 'moment/locale/es';
import Loader from './helpers/Loader';
moment.locale('es');

function Details() {

    const params = useParams();

    const [loading, setloading] = useState(true);
    
    const [errors, seterrors]   = useState({});
    const [slugNotFound, setslugNotFound] = useState(false);

    const [event, setevent]     = useState({});
    const [clientsList, setclientsList] = useState([]);

    const tableRef = useRef(null);

    const getDataBySlug = () => {
      const {codigo} = params;
      if(codigo !== ""){
          setloading(true);

          httpClient.get(`api/evento/ObtenerEventoPorCodigo/${codigo}`)
          .then((res) => {
              console.log(res.data);

              if(res.status = 200){
                  setevent(res.data.configuracion);
                  setclientsList(res.data.usuarios);
                  setloading(false);
              }

          }).catch((err) => {
              setslugNotFound(true);
              setloading(false);
          });
      }else{
          setslugNotFound(true);
          setloading(false);
      }
  }

  useEffect(() => {
    if(loading){
      getDataBySlug();
      document.title = 'Detalles del evento';
    }
  }, [loading]);

  function copytable(el) {
    var body = document.body, range, sel;
    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }

    document.execCommand("Copy");
    toast.info('Data copiada');
  }

  const copyTable = () => {
    copytable(document.getElementById('clients'));
  }

  const header = event.even_AsistPorDia ? 
  ["#", "Ruc", "Razón social", "Nombre", "Apellido", "Teléfono", "Correo", "Día 1", "Día 2", "Fecha de registro"]
  : ["#", "Ruc", "Razón social", "Nombre", "Apellido", "Teléfono", "Correo", "Fecha de registro"];
  const bodyExcel = clientsList.length > 0 ? clientsList.map((item, key) => {
    if(event.even_AsistPorDia){
      return [(key + 1),
        item.edet_NumeroDocumento,
        item.edet_RazonSocial,
        item.edet_Nombre,
        item.edet_Apellidos,
        item.edet_Telefono,
        item.edet_Email,
        item.edet_AsistDia1 ? 'Si' : 'No',
        item.edet_AsistDia2 ? 'Si' : 'No',
        moment(item.edet_FechaCreacion).format("DD-MM-yyyy hh:mm A")]
    }else{
      return [(key + 1),
        item.edet_NumeroDocumento,
        item.edet_RazonSocial,
        item.edet_Nombre,
        item.edet_Apellidos,
        item.edet_Telefono,
        item.edet_Email,
        moment(item.edet_FechaCreacion).format("DD-MM-yyyy hh:mm A")]
    }

  }) : [];

  const handleDownloadExcel = () => {
    downloadExcel({
      title:    "Participantes Registrados",
      fileName: "Participantes Registrados",
      sheet:    "Participantes Registrados",
      tablePayload: {
        header,
        // accept two different data structures
        body: bodyExcel,
      },
    });
  }

  return (
    <div>
        <header className='header-page'>
          <div className="container text-center">
          <div className="row justify-content-center align-items-center">
              <div className="col-lg-7">
                  {!slugNotFound && event &&
                      <img 
                          src={event.even_ImagenBanner} 
                          alt=""
                          className="img-fluid" 
                      />
                  }
              </div>
          </div>
          </div>
      </header>
      <section>

          <div className="content">
              <div className="container-fluid">
                  <div className="row justify-content-center vh-75 align-items-center py-5">
                      <div className="col-lg-12">

                          {!loading && !slugNotFound &&
                            <div className="card shadow w-100">
                                <div className="card-body">
                                    <div className="py-4">

                                        <h2 className='h3 mb-4 fw-bold text-center'>
                                            Detalles del evento
                                        </h2>
                                      
                                        <div className="row justify-content-center mb-4">
                                          <div className="col-lg-8">

                                            <div>
                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Nombre del evento
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {event.even_Nombre}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Descripción del evento
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {event.even_Descripcion}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Url del evento
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {event.even_Url}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Fecha inicio
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {moment(event.even_FechaInicio).format("DD-MM-yyyy")}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Fecha final
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {moment(event.even_FechaFin).format("DD-MM-yyyy")}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Activo: 
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {event.even_Activo ? "Si" : "No"}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="row mb-4">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Fecha de creación
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {moment(event.even_FechaCreacion).format("DD-MM-yyyy")}
                                                  </p>
                                                </div>
                                              </div>

                                              
                                              <div className="row mb-4">
                                                <div className="col-lg-5">
                                                  <h4 className='mb-0 f-normal h6 fw-bold'>
                                                    Solicitar asistencia por día
                                                  </h4>
                                                </div>
                                                <div className="col-lg-7">
                                                  <p className='h6 mb-0 f-normal'>
                                                    {event.even_AsistPorDia ? 'Si' : 'NO'}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                        <div className="row mb-4 align-items-center justify-content-between">
                                          <div className="col-lg-8">
                                            <h2 className='fw-bold h5 mb-0'>
                                              Participantes Registrados
                                            </h2>
                                          </div>
                                          {clientsList.length > 0 &&
                                            <div className="col-lg-2">
                                              <button 
                                                onClick={() => handleDownloadExcel()}
                                                className='btn btn-info w-100 fw-bold'> 
                                                Export excel 
                                              </button>
                                            </div>
                                          }
                                          {clientsList.length > 0 &&
                                            <div className="col-lg-2">
                                              <button onClick={() => copyTable()} className='btn btn-primary fw-bold w-100'>
                                                Copiar
                                              </button>
                                            </div>
                                          }
                                        </div>
                                        
                                        <div className="table-responsive mb-0">
                                            <table ref={tableRef} id='clients' className='table mb-0 table-bordered table-hover table-striped'>
                                              <thead>
                                                  <tr>
                                                      <th style={{ width: '50px'}}>#</th>
                                                      <th>Ruc</th>
                                                      <th>Razón social</th>
                                                      <th>Nombre</th>
                                                      <th>Apellido</th>
                                                      <th>Teléfono</th>
                                                      <th>Correo</th>
                                                      {event.even_AsistPorDia &&
                                                        <>
                                                          <th className='text-center' style={{minWidth: '60px'}}>Día 1</th>
                                                          <th className='text-center' style={{minWidth: '60px'}}>Día 2</th>
                                                        </>
                                                      }
                                                      <th style={{minWidth: '200px'}}>Fecha de Registro</th>
                                                  </tr>
                                              </thead>
                                              <tbody>

                                                {clientsList.length > 0 && clientsList.map((item, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td className='text-primary fw-bold'>
                                                                {(key + 1)}
                                                            </td>
                                                            <td>
                                                              {item.edet_NumeroDocumento}
                                                            </td>
                                                            <td>
                                                              {item.edet_RazonSocial}
                                                            </td>
                                                            <td>
                                                              {item.edet_Nombre}
                                                            </td>
                                                            <td>
                                                              {item.edet_Apellidos}
                                                            </td>
                                                            <td>
                                                              {item.edet_Telefono}
                                                            </td>
                                                            <td>
                                                              {item.edet_Email}
                                                            </td>
                                                            {event.even_AsistPorDia &&
                                                              <>
                                                                <td className='text-center'>
                                                                  {item.edet_AsistDia1 ? 'Si' : 'No'}
                                                                </td>
                                                                <td className='text-center'>
                                                                  {item.edet_AsistDia2 ? 'Si' : 'No'}
                                                                </td>
                                                              </>
                                                            }
                                                            <td>
                                                              {moment(item.edet_FechaCreacion).format("DD-MM-yyyy hh:mm A")}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                                {clientsList.length === 0 &&
                                                  <tr>
                                                      <td className='text-center' colSpan={10}>
                                                          No se han encontrado resultados
                                                      </td>
                                                  </tr>
                                                }

                                              </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                          }

                          {slugNotFound && <Redirect to={`/evento-no-encontrado`} />}

                          {loading &&
                            <Loader full />
                          }

                      </div>
                  </div>
              </div>
          </div>

      </section>
    </div>
  )
}

export default Details